import { GET_ROLE_LIST,GET_ROLES } from '../../types';

export const getRole_list = (data) => {
    return { type: GET_ROLE_LIST, data }
}

export const getRoleList =(data) => {
    return { type: GET_ROLES, data }
}